// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-405739b4]{display:flex;flex-direction:column;align-items:center}.header-name[data-v-405739b4]{color:#fff;font-size:.36rem;font-weight:700;line-height:1rem;height:1rem;text-align:center;width:4.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.header-title[data-v-405739b4]{height:1.3rem;width:5.3rem}", ""]);
// Exports
module.exports = exports;
